<script>
import ButtonAll from '../UI/Button/ButtonAll.vue'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import { globalVariablesMixin } from '../../Mixins/global'
import mixinComponent from '../../Mixins/mixinComponent'

export default {
  components: { ModalDialog, ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    document: { type: Object, required: false },
    uuid: { type: String, required: false },
    url: { type: String, required: false },
  },

  data: () => ({
    loading: false,
  }),
  computed: {
    doc() {
      return this.document || { id: 'from-url-' + Math.random().toString(36).substring(7) }
    },
  },
  methods: {
    closeModal() {
      const pdfModal = document.getElementById('pdf' + this.doc.id)
      const embed = pdfModal.querySelector('embed')
      if (embed) {
        pdfModal.removeChild(embed)
        this.$refs['modal-pdf' + this.doc.id].close()
      }
    },
    async _getFileContent() {
      if (this.url) {
        let absoluteUrl = this.url
        if (!absoluteUrl.startsWith('http')) {
          absoluteUrl = 'https://' + absoluteUrl
        }
        const response = await fetch(absoluteUrl)
        if (!response.ok) {
          throw new Error(this.$t('home.dashboardDocument.errorFetch'))
        }
        return await response.blob()
      } else {
        let apiUrl = ''
        if (this.uuid) {
          apiUrl += 'free/'
        }
        apiUrl += `documents/${this.doc.id}/download${this.uuid ? `?uniqid=${this.uuid}` : ''}`
        return await this.getFile(apiUrl)
      }
    },

    async openModal() {
      this.loading = true

      try {
        const fileContent = await this._getFileContent()
        const dataUrl = window.URL.createObjectURL(fileContent)

        const embed = document.createElement('embed')
        embed.src = dataUrl
        embed.width = '100%'
        embed.height = '500px'
        const pdfModal = document.getElementById('pdf' + this.doc.id)
        pdfModal.appendChild(embed)

        // show the modal
        this.$refs['modal-pdf' + this.doc.id].open()
      } catch (error) {
        this.toast(this.$t('document.modal.titleError'))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<template>
  <template v-if="doc">
    <ButtonAll
      v-bind="$attrs"
      icon="show"
      type="show"
      size="small"
      margin="no"
      :loading="loading"
      name="documentShow"
      @click="openModal"
    />
    <ModalDialog
      :id="'modal-pdf' + doc.id"
      :ref="'modal-pdf' + doc.id"
      class-modal-dialog="modal-xl"
      e2e-modal="modal-pdf"
      @icon-close="closeModal"
    >
      <template #body>
        <div class="form-group row" :id="'pdf' + doc.id"></div>
      </template>
      <template #footer>
        <div class="mt-3">
          <button type="button" class="btn btn-lg btn-primary" e2e-button="close" @click="closeModal">
            {{ $t('main.close') }}
          </button>
        </div>
      </template>
    </ModalDialog>
  </template>
</template>
